// extracted by mini-css-extract-plugin
export default {"container":"yR-z","title":"zR-z","link":"AR-z"};